import requireAll from '@/util/requireAll'

requireAll(require.context('@/assets/css', true, /.*$/))
